
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({name: 'GmailLogo'})
export default class GmailLogo extends Vue {
  @Prop({default: 24}) size!: number;
}
